import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Склеивает классы и разрешает конфликты Tailwind: последний утилитарный класс побеждает. */
export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
